import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Button from "@scentregroup/ui/components/form/button";
import DateRangeFilter from '../date-range-filter';
import WhatsHappeningMultiFilterV2 from '../whats-happening-multi-filter-v2';
import trackClickEvent from '../../helpers/analytics-utils/track-event';
import { categories, actions } from '../../helpers/analytics-utils/constants';
import WhatsHappeningFiltersWrapper from './wrapper';
import styles from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const trackReset = () => {
  trackClickEvent(categories.WHATS_HAPPENING_FILTERS, actions.RESET_FILTERS, undefined);
};
const WhatsHappeningFilters = _ref => {
  let {
    dateRangeProps,
    onResetFilters,
    contentTypesProps,
    topicsProps,
    experiencesProps
  } = _ref;
  const count = [contentTypesProps, topicsProps, experiencesProps].reduce((a, c) => a + ((c === null || c === void 0 ? void 0 : c.selectedOptions) || []).length, 0);
  return /*#__PURE__*/_jsx(WhatsHappeningFiltersWrapper, {
    count: count,
    "data-id": "whats-happening-filters_index_WhatsHappeningFilters_WhatsHappeningFiltersWrapper",
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(DateRangeFilter, _objectSpread(_objectSpread({}, dateRangeProps), {}, {
        "data-id": "whats-happening-filters_index_WhatsHappeningFilters_DateRangeFilter"
      })), /*#__PURE__*/_jsx(WhatsHappeningMultiFilterV2, _objectSpread(_objectSpread({}, contentTypesProps), {}, {
        "data-id": "whats-happening-filters_index_WhatsHappeningFilters_WhatsHappeningMultiFilterV2"
      })), /*#__PURE__*/_jsx(WhatsHappeningMultiFilterV2, _objectSpread(_objectSpread({}, topicsProps), {}, {
        "data-id": "whats-happening-filters_index_WhatsHappeningFilters_WhatsHappeningMultiFilterV2_3"
      })), /*#__PURE__*/_jsx(WhatsHappeningMultiFilterV2, _objectSpread(_objectSpread({}, experiencesProps), {}, {
        "data-id": "whats-happening-filters_index_WhatsHappeningFilters_WhatsHappeningMultiFilterV2_4"
      })), /*#__PURE__*/_jsx("div", {
        className: styles.reset,
        "data-id": "whats-happening-filters_index_WhatsHappeningFilters_div",
        children: /*#__PURE__*/_jsx(Button, {
          type: "tertiary",
          className: styles.resetButton,
          onClick: () => {
            onResetFilters();
            trackReset();
          },
          "data-id": "whats-happening-filters_index_WhatsHappeningFilters_div_Button",
          children: "Reset filters"
        })
      })]
    })
  });
};
export default WhatsHappeningFilters;